import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  SAVE_CONFIG_BENCHMARK_WATCHER,
  SAVE_CONFIG_BENCHMARK_SUCCESS,
  SAVE_CONFIG_BENCHMARK_FAILED,
} from "./constants"

export function getStatusWatcher(payload) {
  return { type: GET_STATUS_WATCHER, payload }
}

export function getStatusSuccess(payload) {
  return { type: GET_STATUS_SUCCESS, payload }
}

export function getStatusFailed() {
  return { type: GET_STATUS_FAILED }
}

export function getMeasureColorRangeWatcher(payload) {
  return { type: GET_MEASURE_COLOR_RANGE_WATCHER, payload }
}

export function getMeasureColorRangeSuccess(payload) {
  return { type: GET_MEASURE_COLOR_RANGE_SUCCESS, payload }
}

export function getMeasureColorRangeFailed() {
  return { type: GET_MEASURE_COLOR_RANGE_FAILED }
}

export function saveConfigBenchmarkWatcher(payload) {
  return { type: SAVE_CONFIG_BENCHMARK_WATCHER, payload }
}

export function saveConfigBenchmarkSuccess(payload) {
  return { type: SAVE_CONFIG_BENCHMARK_SUCCESS, payload }
}

export function saveConfigBenchmarkFailed() {
  return { type: SAVE_CONFIG_BENCHMARK_FAILED }
}
